import { GenericError } from '@psyomics/ui-components';
import { useParams } from 'react-router-dom';

import { Survey as SurveyFeature } from '../../../features/survey/survey';

type QuestionnaireProps = { readonly reviewMode?: boolean };

const Questionnaire = ({ reviewMode = false }: QuestionnaireProps) => {
  const { id: invitePublicId } = useParams();
  if (!invitePublicId) {
    return <GenericError />;
  }
  return <SurveyFeature invitePublicId={invitePublicId} reviewMode={reviewMode} />;
};

export default Questionnaire;
